import { request } from "../../helpers/requestHelper";
import { returnMsg } from "../../helpers/shop/paymentHelper";
import { retryPayment } from './retryPayment';
import { msg as swalMsg } from "../swal_msg";

import { SUPPORT_NUMBER_VIEW } from "../../constants/constants";

export const openPayCharge = async(model) => {
    try {
        const resp = await request('payment/openpay/charge', model, 'POST');
        const body = await resp.json();
        if (body.status) return body;
        else return returnMsg(body, 'OpenPay', model);
    } catch (err) {
        swalMsg('error', 'Checkout',
        `No se pudo registrar el pedido. Comuníquese con nosotros: ${SUPPORT_NUMBER_VIEW}`);
        return { status: false };
    };
};

// registrar pedido con OpenPay (intento sin promociones expiradas)
export const openPayChargeFn = async(model, cartData) => {
    try {
        const resp = await request('payment/openpay/charge', model, 'POST');
        const body = await resp.json();
        if (body.status)
            return { ...body, cartData: { ...cartData } };
        else {
            if (body.msg === 'session-not-generated') {
                swalMsg('warning', 'Checkout',
                'No se pudo proceder con el pago');
                return { status: false, cartData: { ...cartData } };
            } else return returnMsg(body, 'OpenPay', model);
        }
    } catch (err) {
        swalMsg('error', 'Checkout',
        `No se pudo registrar el pedido. Comuníquese con nosotros: ${SUPPORT_NUMBER_VIEW}`);
        return { status: false, cartData: { ...cartData } };
    };
};

// otbener enlace de pago con OpenPay
// nuevo intento de pago (pedido ya registrado)
export const openPayPayment = (_id, setDisabled) => {
    return retryPayment('OpenPay', _id, setDisabled);
};
